module.exports = __webpack_public_path__ + "img/GB-UKM.c53bf252.svg";